import * as api from '../api/eInvoice'
import { AddressTypesByCountryInterface } from '../Interfaces/EInvoiceInterface'
import { actionCreatorAsync, AsyncAction } from './index'

export function getAddressTypes(
  existing?: AddressTypesByCountryInterface,
): AsyncAction<AddressTypesByCountryInterface> {
  return actionCreatorAsync<AddressTypesByCountryInterface>('GET_ADDRESS_TYPES', async () => {
    return existing ? Promise.resolve(existing) : api.getAddressTypes()
  })
}
